export default __webpack_public_path__ + "static/media/CL08.bcbc347e.mp3";